export interface SubMenuProp {
    className?: string;
    submenukey?: string;
    children: JSX.Element | JSX.Element[];
}
  
const LogoutSubMenu = (props: SubMenuProp) => {
    return <div className={props.className}>{props.children}</div>;
};

export default LogoutSubMenu;